// Modules
import React from "react";
import { useStaticQuery, graphql } from "gatsby";

// Components
import ColumnsRow from "./columnsRow";

// Helpers
import chunk from "../../helpers/chunk";
import generateRandomId from "../../helpers/generateRandomId";
import TYPES_OF_LISTS from "../../constants/typesOfLists";

// Styles
import * as style from "./columns.module.scss";

const Columns = (props) => {
  const { amountInRow, background, columns, color, title, type, border } = props;

  const { allSanityNav } = useStaticQuery(graphql`
    {
      allSanityNav {
        nodes {
          _rawMainNavLinkItem(resolveReferences: { maxDepth: 20 })
        }
      }
    }
  `);
  const { _rawMainNavLinkItem } = allSanityNav?.nodes[0];
  const links =
    _rawMainNavLinkItem &&
    _rawMainNavLinkItem.find((item) => item._type === TYPES_OF_LISTS.Array)
      ?.leftCol.columnLink;
  const linksArray = chunk(links, amountInRow);

  const wrapperStyle = { backgroundColor: background };
  const data = chunk(columns, amountInRow);
  return (
    <div className={style.wrapper} style={wrapperStyle}>
      {title && <h4 style={{ color: color }}>{title}</h4>}
      {data.map((arr) => (
        <ColumnsRow
          arr={arr}
          linksArray={linksArray}
          key={generateRandomId()}
          type={type}
          border={border}
          amountInRow={amountInRow}
        />
      ))}
    </div>
  );
};

export default Columns;
